import type { ReactNode } from 'react';

export const inputClass =
  'w-full rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400';

interface FieldProps {
  label: string;
  required?: boolean;
  hint?: string;
  children: ReactNode;
}

export default function Field({ label, required, hint, children }: FieldProps) {
  return (
    <label className="flex w-full flex-col gap-1.5">
      <span className="text-sm font-medium text-foreground-800">
        {label}
        {required && <span className="ml-0.5 text-accent-600">*</span>}
      </span>
      {children}
      {hint && <span className="text-xs text-foreground-500">{hint}</span>}
    </label>
  );
}